var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"change-payment-method"},[_c('div',{staticClass:"title"},[_vm._v("Payment method")]),(_vm.payment)?_c(_setup.PaymentMethod,{attrs:{"payment":_vm.payment}}):_vm._e(),_c('md-button',{staticClass:"md-primary",on:{"click":_setup.changePaymentMethod}},[_vm._v("Change payment method")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }